import React, { useState, useEffect, useMemo } from 'react'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import Dropdown from '@jimmyboys/liita-ui/dist/components/Dropdown'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { useFetchList } from 'store'

import { API_URL, fetchOptions, parseJSONContent } from 'store/fetchUtils'
import TaskHeaderErrors from 'components/TaskHeaderErrors/TaskHeaderErrors'

import styles from './Dialog.module.sass'
import { useReload } from 'store'

const AddCommentToThread = (props) => {
	const { className, data, dismiss, resolve } = props

	const { i18n, expireSession, pushNotification } = useGlobal()

	const [parent, setParent] = useState(null)
	const [submitting, setSubmitting] = useState(false)
	const [error, setError] = useState(null)

	const reload = useReload()

	const {
		contents: [comments = []],
	} = useFetchList(
		[`/clinical_processes/${data?.processId}/comments`],
		[
			(json) => {
				return {
					value: `${json.id}`,
					text: `#${json.id} - ${i18n.translate(json.title)}`,
				}
			},
		]
	)

	const otherComments = useMemo(
		() => comments.filter((item) => +item.value !== +data.commentId),
		[comments, data.commentId]
	)

	useEffect(() => {
		if (data.parentId && !parent) {
			setParent(data.parentId)
		}
	}, [parent, data.parentId])

	const handleSubmit = (e) => {
		e.preventDefault()
		if (submitting) {
			return
		}

		const url = `${API_URL}/api/clinical_processes/${data?.processId}/comments/parent`

		setError(null)
		setSubmitting(true)

		fetch(
			url,
			fetchOptions({
				method: 'PUT',
				body: { commentId: +data.commentId, parent: +parent },
			})
		)
			.then((r) => parseJSONContent(r))
			.then(() => {
				reload([`/clinical_processes/${data?.processId}/comments`])
				setSubmitting(false)
				resolve && resolve(parent)
				pushNotification(
					undefined,
					'success',
					i18n`Comment associated successfully!`
				)
			})
			.catch((err) => {
				if (err.status === '401' || err.status === 401) {
					expireSession()
				}

				setSubmitting(false)
			})
	}
	return (
		<>
			<TaskHeaderErrors errors={error ?? []} />
			<form
				id={`form_notifications`}
				className={`${styles['root'] || ''} ${className || ''}`}
				onSubmit={handleSubmit}
				disabled={submitting}
			>
				<fieldset>
					<Dropdown
						placeholder={i18n`Associate to`}
						value={parent}
						searchable
						options={otherComments}
						onChange={(e) => {
							setParent(e.target.value)
						}}
					/>
				</fieldset>
			</form>
			<menu>
				<ActionButton type='button' secondary onClick={dismiss}>
					<small>
						<strong>{i18n`Cancel`}</strong>
					</small>
				</ActionButton>
				<ActionButton form={`form_notifications`} primary>
					<small>
						<strong>
							{submitting ? i18n`Submitting` : i18n`Send`}
						</strong>
					</small>
				</ActionButton>
			</menu>
		</>
	)
}

export default AddCommentToThread
